import React, { useState, useEffect } from 'react';
import { Pane, Paragraph, Checkbox } from 'evergreen-ui';

const ConversionSettings = (props) => {
    const [pdfChecked, setPdfChecked] = useState(false);
    const [epubChecked, setEpubChecked] = useState(false);
    const [coverChecked, setCoverChecked] = useState(false);
    const [noCoverChecked, setNoCoverChecked] = useState(false);
    const [pdfCoverChecked, setPdfCoverChecked] = useState(false);

    return (
    	<Pane>
            <Paragraph size={300}>Note: Default setting will export all formats and files.</Paragraph>
            <Checkbox 
                label="Export PDF only" 
                checked={pdfChecked} 
                onChange={e => {
                    props.updateConversionSettings({
                        pdfOnly: e.target.checked,
                        epubOnly: false,
                        coverOnly: false
                    });
                    setPdfChecked(e.target.checked);
                    setEpubChecked(false);
                    setCoverChecked(false);
                }}
            />
            <Checkbox 
                label="Export EPUB only" 
                checked={epubChecked} 
                onChange={e => {
                    props.updateConversionSettings({
                        pdfOnly: false,
                        epubOnly: e.target.checked,
                        coverOnly: false
                    });
                    setPdfChecked(false);
                    setEpubChecked(e.target.checked);
                    setCoverChecked(false);
                }}
            />
            <Checkbox 
                label="Export cover only" 
                checked={coverChecked} 
                onChange={e => {
                    props.updateConversionSettings({
                        pdfOnly: false,
                        epubOnly: false,
                        coverOnly: e.target.checked
                    });
                    setPdfChecked(false);
                    setEpubChecked(false);
                    setCoverChecked(e.target.checked);
                }}
            />
            <hr />
            <Checkbox 
                label="Export without cover" 
                checked={noCoverChecked} 
                onChange={e => {
                    props.updateConversionSettings({noCover: e.target.checked});
                    setNoCoverChecked(e.target.checked);
                }}
            />
            <Checkbox 
                label="PDF has cover attached" 
                checked={pdfCoverChecked} 
                onChange={e => {
                    props.updateConversionSettings({pdf_has_cover: e.target.checked});
                    setPdfCoverChecked(e.target.checked);
                }}
            />
        </Pane>
    )
}

export default ConversionSettings;